import React from 'react';
import contactPageStyles from './index.module.css';
import Grid from '@material-ui/core/Grid';
import BookAMeeting from './Meeting';
import BookADemo from './Demo';
import Footer from '../../Footer';
import { ContactBackdrop, ContactIllustration } from './ContactDecor';

class MainSection extends React.Component {
  render() {
    return (
      <section className={`${contactPageStyles.mainSection} section`}>
        <ContactBackdrop />
        <Grid container spacing={0} className={`${contactPageStyles.mainSectionTop} contentContainer`} alignContent="center">
          <Grid item xs={12} className="textAlignCenter">
            <div className={`${contactPageStyles.sectionTitle} sectionTitle`}>Contact Us</div>
            <div className={`sectionTitleUnderline ul-center`} />
            <div className={`articleBigTitle ${contactPageStyles.contactHeadline}`}>Let&apos;s talk</div>
            <p className={contactPageStyles.contactIntro}>
              Whether you&apos;re scaling up or just getting started, we&apos;re happy to help—book a demo or reach us by email.
            </p>
            <ContactIllustration />
          </Grid>
        </Grid>
        <div className={`${contactPageStyles.mainSectionBottom} contentContainer`}>
          <Grid
            container
            spacing={4}
            justify="center"
            className={contactPageStyles.formRow}
          >
            <Grid item md={6} xs={12}>
              <BookADemo />
            </Grid>
            <Grid item md={6} xs={12}>
              <BookAMeeting />
            </Grid>
          </Grid>
        </div>

        <Footer />
      </section>
    );
  }
}

export default MainSection;